// extracted by mini-css-extract-plugin
module.exports = {"CreatePage":"CreatePage_CreatePage__NZtPs","LoginForm":"CreatePage_LoginForm__2AsOd","EmailInput":"CreatePage_EmailInput__3hXs_","PasswordInput":"CreatePage_PasswordInput__1HqUM"};